import { gql } from '@apollo/client';

export const BATCH_WORK_ASSIGNMENTS_MAKE_ACTUAL_V2 = gql`
	mutation batchWorkAssignmentsMakeActualV2($input: WorkAssignmentBatchMakeActualInput!) {
		batchWorkAssignmentsMakeActualV2(input: $input) {
			__typename
			... on WorkAssignmentBatchMutationSuccessResponseV2 {
				workAssignmentSequences {
					crewMember {
						fullName
					}
					fromStation {
						code
					}
					toStation {
						code
					}
				}
			}
			... on WorkAssignmentBatchMutationErrorResponse {
				errors {
					errors
				}
			}
		}
	}
`;
